import { render, staticRenderFns } from "./VKL.vue?vue&type=template&id=525d59e2&scoped=true"
import script from "./VKL.vue?vue&type=script&lang=js"
export * from "./VKL.vue?vue&type=script&lang=js"
import style0 from "./VKL.vue?vue&type=style&index=0&id=525d59e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d59e2",
  null
  
)

export default component.exports